import "@/App.css";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "sonner";

import {
  ThemeProvider,
  useTheme,
} from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { WalletProvider } from "@/context/WalletContext";

import Layout from "@/components/Layout";

import SignUp from "@/pages/SignUp";
import LandingPage from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ServicesPage from "@/pages/Services";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import LoginPage from "@/pages/Login";
import {PrivacyPage, TermsPage,} from "@/pages/Legal";
import Ledger from "./pages/Ledger";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import WalletTopUp from "./pages/WalletTopUp";

import fillMyFormRoutes from "./pages/FillMyForm/routes";
import modifyMyFormRoutes from "./pages/ModifyMyForm/routes";




const AppShell = () => {
  const { theme } = useTheme();

  return (
    <>
      <Layout>
        <Routes>
          <Route
            path="/"
            element={<LandingPage />}
          />

          <Route
            path="/signup"
            element={<SignUp />}
          />          

          <Route
            path="/dashboard"
            element={<Dashboard />}
          />

          <Route
            path="/services"
            element={<ServicesPage />}
          />

          <Route
            path="/about"
            element={<AboutPage />}
          />

          <Route
            path="/contact"
            element={<ContactPage />}
          />

          <Route
            path="/login"
            element={<LoginPage />}
          />

        <Route path="/ledger" element={<Ledger />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/change-password" element={<ChangePassword />} /> 
        {/* <Route path="/wallet/topup" element={<WalletTopUp />} />    */}
        <Route path="/wallet" element={<WalletTopUp />} />   

          <Route
            path="/privacy"
            element={<PrivacyPage />}
          />

          <Route
            path="/terms"
            element={<TermsPage />}
          />

    {/* Fill My Form routes */}
    {fillMyFormRoutes.map((route) => (
        <Route
            key={route.path}
            path={route.path}
            element={route.element}
        />
    ))}          

    {/* Modify My Form routes */}
    {modifyMyFormRoutes.map((route) => (
      <Route
        key={route.path}
        path={route.path}
        element={route.element}
      />
    ))}

          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />

        </Routes>
      </Layout>

      <Toaster
        position="top-right"
        theme={theme}
        richColors
        closeButton
        toastOptions={{
          style: {
            borderRadius: "14px",
          },
        }}
      />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <WalletProvider>
            <AppShell />
          </WalletProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
